export class WhatIsSampleRequestModalDataEntityModel {
    /**
     * 0, 1 => 1 なら会員訴求を表示しない
     */
    hide_flg_what_is_sample_request: string | undefined = undefined;

}
